/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LlgResourcePolicy } from '../models/LlgResourcePolicy';

export class BatchUpdateLlgPolicyItem {
  /**
  * ID of the log source to update the policy for.
  */
  'logSourceId': string;
  'policy': LlgResourcePolicy | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "logSourceId",
      "baseName": "logSourceId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "policy",
      "baseName": "policy",
      "type": "LlgResourcePolicy",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BatchUpdateLlgPolicyItem.attributeTypeMap;
  }

  public constructor() {
  }
}

